export default __webpack_public_path__ + "static/media/es.039cad8d.svg";